import React from 'react';
import { Award } from 'lucide-react';

const TopRatedBadge = ({ size = 'medium' }) => {
  const sizeConfig = {
    small: { badge: 'tr-badge-sm', icon: 14, text: 'Top Rated' },
    medium: { badge: 'tr-badge-md', icon: 18, text: 'Top Rated' },
  };

  const config = sizeConfig[size];

  return (
    <div className={`tr-badge ${config.badge}`} data-testid="top-rated-badge">
      <div className="tr-badge-inner">
        <Award size={config.icon} className="tr-award" />
        <span className="tr-text">{config.text}</span>
      </div>
      <div className="tr-shine"></div>
    </div>
  );
};

export default TopRatedBadge;
